// 网络错误提示信息
const MSG_NETWORK_ERR = '系统繁忙，请稍后重试'

// 公共的数值类型是、否
const COMMON_YES_NO = {
  NO: 0,
  YES: 1
}

// localStorage的key
const LS_KEYS = {
  deviceId: 'deviceId'
}
const InvoiceIdentifyList = [
  {"value": "-2", "label": "线下打款审核通过"},
  {"value": "-1", "label": "待确认"},
  {"value": "0", "label": "待审核"},
  {"value": "1", "label": "开票中"},
  {"value": "2", "label": "开票成功"},
  {"value": "3", "label": "开票失败"},
  {"value": "4", "label": "已作废"},
  {"value": "5", "label": "全额红冲"},
  {"value": "6", "label": "驳回"},
  {"value": "7", "label": "待客户确认"},
  {"value": "8", "label": "已取消"},
  {"value": "9", "label": "运维生成"}]
export {
  InvoiceIdentifyList,
  MSG_NETWORK_ERR,
  COMMON_YES_NO,
  LS_KEYS
}



// WEBPACK FOOTER //
// ./src/util/constants.js